/* iFlip Store Kenya — theme behaviour */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cfg = window.iflip || { routes: {}, currencyLabel: 'Ksh' };
  var root = (cfg.routes.root || '/').replace(/\/$/, '');

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    return (cfg.currencyLabel || 'Ksh') + ' ' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || '[]');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return val === undefined ? [] : null; }
  }
  var toastTimer;
  function toast(msg) {
    var t = $('#ifToast'); if (!t) return;
    t.innerHTML = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }

  /* ---------- Lipa Polepole maths (shared) ---------- */
  var lipaCfg = cfg.lipa || {};
  var lipa = window.iflipLipa = {
    deposits: String(lipaCfg.deposits || '40,50,60').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0 && x < 100; }),
    markups: (function () { var m = {}; String(lipaCfg.markup || '').split(',').forEach(function (p) { var kv = p.split('='); if (kv.length === 2) m[parseInt(kv[0], 10)] = parseFloat(kv[1]) || 0; }); return m; })(),
    popular: parseInt(lipaCfg.popular, 10) || 3,
    plan: function (price, depPct, months, weekly) {
      var dep = Math.round(price * depPct / 100);
      var bal = price - dep;
      var mk = lipa.markups[months] || 0;
      var repay = Math.round(bal * (1 + mk / 100));
      var n = weekly ? Math.round(months * 30 / 7) : months;
      return { deposit: dep, balance: bal, repayable: repay, count: n, installment: Math.ceil(repay / n), total: dep + repay, markup: mk };
    }
  };

  /* ---------- drawers ---------- */
  var lastFocus;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('.if-close'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.if-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeSearch(); closeDesk(); }
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); }
  });

  /* ---------- sticky header shadow ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- hero slider ---------- */
  $$('[data-slider]').forEach(function (s) {
    var track = $('[data-slider-track]', s), slides = track ? track.children : [], dots = $$('[data-slider-dots] button', s);
    var n = slides.length, i = 0, timer, speed = parseInt(s.getAttribute('data-autoplay'), 10) || 0;
    if (n < 2) return;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function play() { if (speed) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed * 1000); } }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
    var p = $('[data-slider-prev]', s), nx = $('[data-slider-next]', s);
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    s.addEventListener('mouseenter', function () { clearInterval(timer); });
    s.addEventListener('mouseleave', play);
    var x0 = null;
    s.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    s.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); } x0 = null;
    });
    play();
  });

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    var box = $('[data-cart-items]'), sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<div class="if-cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 7h12l1 14H5L6 7z"/><path d="M9 7V6a3 3 0 0 1 6 0v1"/></svg><p><strong style="color:var(--c-ink)">Your bag is empty</strong></p><p style="margin:6px 0 18px">Explore genuine iPhones, Galaxy & MacBooks.</p><a href="' + root + '/collections/all" class="btn btn--primary btn--sm">Start Shopping</a></div>';
      return;
    }
    box.innerHTML = cart.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="if-citem__variant">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="if-citem" data-key="' + it.key + '">' +
        '<a href="' + it.url + '" class="if-citem__img">' + (it.image ? '<img src="' + imgUrl(it.image, 160) + '" alt="">' : '') + '</a>' +
        '<div><a href="' + it.url + '" class="if-citem__title">' + esc(it.product_title) + '</a>' + variant +
        '<div class="if-citem__row"><div class="if-qty" data-line-qty="' + it.key + '"><button type="button" data-q="-1" aria-label="Decrease">&minus;</button><input type="number" value="' + it.quantity + '" min="0" aria-label="Quantity"><button type="button" data-q="1" aria-label="Increase">+</button></div>' +
        '<strong>' + money(it.final_line_price) + '</strong></div>' +
        '<button type="button" class="if-citem__remove" data-remove="' + it.key + '">Remove</button></div></div>';
    }).join('');
  }
  function fetchCart() { return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(key, qty) {
    return fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(formData) {
    return fetch(root + '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    if (o && $('#ifCartDrawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); fetchCart().then(renderCart); openDrawer('ifCartDrawer');
    }
    var q = e.target.closest('[data-line-qty] [data-q]');
    if (q) {
      var wrap = q.closest('[data-line-qty]'), inp = $('input', wrap);
      changeLine(wrap.getAttribute('data-line-qty'), Math.max(0, parseInt(inp.value, 10) + parseInt(q.getAttribute('data-q'), 10)));
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) changeLine(rm.getAttribute('data-remove'), 0);
  });
  document.addEventListener('change', function (e) {
    var wrap = e.target.closest('[data-line-qty]');
    if (wrap) changeLine(wrap.getAttribute('data-line-qty'), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  /* ---------- quantity steppers (product page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-minus],[data-qty-plus]'); if (!b) return;
    var inp = $('input', b.closest('[data-qty]'));
    var v = parseInt(inp.value, 10) || 1;
    inp.value = Math.max(1, v + (b.hasAttribute('data-qty-plus') ? 1 : -1));
  });

  /* ---------- product page ---------- */
  var ps = $('[data-product-section]');
  var pjson = $('[data-product-json]');
  if (ps && pjson) {
    var product = JSON.parse(pjson.textContent);
    var form = $('[data-product-form]', ps);
    var idInput = $('[data-variant-id]', ps);
    var atc = $('[data-add-to-cart]', ps), buyNow = $('[data-buy-now]', ps), atcLabel = $('[data-atc-label]', ps);
    var stock = $('[data-stock]', ps), soldBox = $('[data-soldout-box]');
    var priceEl = $('[data-price]', ps), compEl = $('[data-compare-price]', ps), saveEl = $('[data-save]', ps);
    var sticky = $('[data-sticky-atc]'), stickyPrice = $('[data-sticky-price]'), stickyAdd = $('[data-sticky-add]');
    var inStockText = stock ? stock.textContent.trim() : 'In Stock';
    var slidesBox = $('[data-gallery-slides]', ps), thumbs = $$('[data-thumb]', ps);

    var goToSlide = function (idx) {
      if (!slidesBox) return;
      slidesBox.scrollTo({ left: slidesBox.clientWidth * idx, behavior: 'smooth' });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === idx); });
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goToSlide(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    if (slidesBox) slidesBox.addEventListener('scroll', function () {
      var idx = Math.round(slidesBox.scrollLeft / slidesBox.clientWidth);
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === idx); });
    }, { passive: true });

    var selected = function () {
      var opts = [];
      product.options.forEach(function (_, i) {
        var c = $('input[data-option-index="' + i + '"]:checked', ps);
        opts.push(c ? c.value : null);
      });
      return opts;
    };
    var findVariant = function (opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    };
    var markAvailability = function (opts) {
      product.options.forEach(function (_, i) {
        $$('input[data-option-index="' + i + '"]', ps).forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var v = findVariant(test);
          var lbl = inp.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };
    var update = function () {
      var opts = selected(), v = findVariant(opts);
      opts.forEach(function (o, i) { var l = $('[data-option-label="' + i + '"]', ps); if (l) l.textContent = o; });
      markAvailability(opts);
      if (!v) {
        atc.disabled = true; buyNow.disabled = true; if (stickyAdd) stickyAdd.disabled = true;
        atcLabel.textContent = 'Unavailable'; stock.textContent = 'This combination is unavailable'; stock.classList.add('is-out');
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compEl.hidden = false; compEl.textContent = money(v.compare_at_price);
        saveEl.hidden = false; saveEl.textContent = 'Save ' + money(v.compare_at_price - v.price);
      } else { compEl.hidden = true; saveEl.hidden = true; }
      atc.disabled = !v.available; buyNow.disabled = !v.available; if (stickyAdd) stickyAdd.disabled = !v.available;
      atcLabel.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      stock.textContent = v.available ? inStockText : 'Out of stock';
      stock.classList.toggle('is-out', !v.available);
      if (soldBox) {
        soldBox.classList.toggle('is-visible', !v.available);
        var nb = $('[data-notify-body]', soldBox); if (nb) nb.value = 'Back in stock request: ' + product.title + ' — ' + v.title;
      }
      if (v.featured_media && slidesBox) {
        var target = $$('.if-gallery__slide', slidesBox).findIndex(function (sl) { return sl.getAttribute('data-media-id') == v.featured_media.id; });
        if (target > -1) goToSlide(target);
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    $$('input[data-option-index]', ps).forEach(function (inp) { inp.addEventListener('change', update); });
    if (product.options.length) markAvailability(selected());

    var submitAdd = function (thenCheckout) {
      var fd = new FormData(form);
      atc.classList.add('is-disabled');
      return addToCart(fd).then(function () {
        if (thenCheckout) { window.location.href = '/checkout'; return; }
        return fetchCart().then(function (c) { renderCart(c); openDrawer('ifCartDrawer'); });
      }).catch(function (err) {
        toast(esc((err && (err.description || err.message)) || 'Could not add to cart'));
      }).then(function () { atc.classList.remove('is-disabled'); });
    };
    form.addEventListener('submit', function (e) { e.preventDefault(); submitAdd(false); });
    buyNow.addEventListener('click', function () { submitAdd(true); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { submitAdd(false); });

    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atc);
    }
  }

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach(function (tabs) {
    var btns = $$('[data-tab]', tabs);
    var show = function (name) {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-tab') === name;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-tab')); }); });
    $$('[data-open-tab]').forEach(function (a) { a.addEventListener('click', function () { show(a.getAttribute('data-open-tab')); }); });
  });

  /* ---------- share ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-share]'); if (!s) return;
    var data = { title: s.getAttribute('data-share-title') || document.title, url: window.location.href.split('?')[0] };
    if (navigator.share) { navigator.share(data).catch(function () {}); }
    else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { toast('Link copied'); }); }
  });

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { box.innerHTML = inner.innerHTML; syncToggles(); }
      else box.style.display = 'none';
    }).catch(function () {});
  });

  /* ---------- wishlist + compare (localStorage) ---------- */
  var WL = 'iflip_wishlist', CMP = 'iflip_compare', CMP_MAX = 4;
  function syncToggles() {
    var wl = store(WL), cmp = store(CMP);
    $$('[data-wishlist-toggle]').forEach(function (b) { b.classList.toggle('is-active', wl.indexOf(b.getAttribute('data-wishlist-toggle')) > -1); });
    $$('[data-compare-toggle]').forEach(function (b) { b.classList.toggle('is-active', cmp.indexOf(b.getAttribute('data-compare-toggle')) > -1); });
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = wl.length; el.setAttribute('data-count', wl.length); });
    $$('[data-compare-count]').forEach(function (el) { el.textContent = cmp.length; el.setAttribute('data-count', cmp.length); });
    var bar = $('[data-compare-bar]');
    if (bar) bar.classList.toggle('is-visible', cmp.length > 0 && !document.body.classList.contains('page-compare'));
  }
  function toggleIn(key, handle, max) {
    var list = store(key), i = list.indexOf(handle), added = i === -1;
    if (added) { if (max && list.length >= max) list.shift(); list.push(handle); } else list.splice(i, 1);
    store(key, list); syncToggles(); return added;
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wishlist-toggle]');
    if (w) { e.preventDefault(); toast(toggleIn(WL, w.getAttribute('data-wishlist-toggle')) ? '❤️ Saved to wishlist' : 'Removed from wishlist'); }
    var c = e.target.closest('[data-compare-toggle]');
    if (c) { e.preventDefault(); toast(toggleIn(CMP, c.getAttribute('data-compare-toggle'), CMP_MAX) ? 'Added to compare (max ' + CMP_MAX + ')' : 'Removed from compare'); }
    if (e.target.closest('[data-compare-clear]')) { store(CMP, []); syncToggles(); renderCompare(); }
    var st = e.target.closest('[data-compare-set]');
    if (st) { e.preventDefault(); store(CMP, st.getAttribute('data-compare-set').split(',').filter(Boolean).slice(0, CMP_MAX)); syncToggles(); renderCompare(); var b = document.querySelector('[data-compare-page]'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    if (c && document.querySelector('[data-compare-page]')) setTimeout(renderCompare, 30);
  });
  syncToggles();

  function getProducts(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch(root + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) { return list.filter(Boolean); });
  }
  function specRows(html) {
    var d = document.createElement('div'); d.innerHTML = (html || '').replace(/<\/(li|p|div|h\d)>|<br\s*\/?>/gi, '\n');
    var map = {};
    d.textContent.split('\n').forEach(function (l) {
      l = l.trim(); var k = l.indexOf(':');
      if (k > 0 && k < 34) map[l.slice(0, k).trim()] = l.slice(k + 1).trim();
    });
    return map;
  }
  function renderCompare() {
    var box = $('[data-compare-page]'); if (!box) return;
    var handles = store(CMP), empty = document.querySelector('[data-compare-empty]');
    if (empty) empty.hidden = handles.length > 0;
    if (!handles.length) { box.innerHTML = empty ? '' : '<div class="if-empty"><h3>No devices to compare yet</h3><p>Tap the compare icon on any product card to add up to ' + CMP_MAX + ' devices.</p><a href="' + root + '/collections/all" class="btn btn--primary mt-16">Browse Devices</a></div>'; return; }
    box.innerHTML = '<p style="color:var(--c-muted)">Loading devices…</p>';
    getProducts(handles).then(function (ps) {
      var specs = ps.map(function (p) { return specRows(p.description); });
      var keys = [];
      specs.forEach(function (m) { Object.keys(m).forEach(function (k) { if (keys.indexOf(k) === -1) keys.push(k); }); });
      var head = '<tr><th>Device</th>' + ps.map(function (p, i) {
        return '<td><a href="' + p.url + '">' + (p.featured_image ? '<img src="' + imgUrl(p.featured_image, 300) + '" alt="">' : '') + '<strong style="display:block">' + esc(p.title) + '</strong></a>' +
          '<div style="color:var(--c-primary);font-weight:900;margin:6px 0 10px">' + money(p.price) + '</div>' +
          '<a href="' + p.url + '" class="btn btn--primary btn--sm">Buy</a> <button type="button" class="btn btn--outline btn--sm" data-compare-toggle="' + p.handle + '" data-compare-remove>Remove</button></td>';
      }).join('') + '</tr>';
      var rows = '<tr><th>Brand</th>' + ps.map(function (p) { return '<td>' + esc(p.vendor) + '</td>'; }).join('') + '</tr>' +
        '<tr><th>Lipa Polepole</th>' + ps.map(function (p) { var pl = lipa.plan(p.price / 100, lipa.deposits[0] || 40, lipa.popular); return '<td><strong>' + money(pl.installment * 100) + '</strong>/mo × ' + pl.count + '<br><small style="color:var(--c-muted)">' + money(pl.deposit * 100) + ' deposit (' + (lipa.deposits[0] || 40) + '%)</small></td>'; }).join('') + '</tr>' +
        '<tr><th>Availability</th>' + ps.map(function (p) { return '<td>' + (p.available ? '<span style="color:var(--c-success);font-weight:700">In Stock</span>' : '<span style="color:var(--c-danger);font-weight:700">Sold Out</span>') + '</td>'; }).join('') + '</tr>' +
        keys.map(function (k) { return '<tr><th>' + esc(k) + '</th>' + specs.map(function (m) { return '<td>' + esc(m[k] || '—') + '</td>'; }).join('') + '</tr>'; }).join('');
      box.innerHTML = '<div class="if-cmp-bar"><strong>' + ps.length + ' of ' + CMP_MAX + ' devices</strong><button type="button" class="btn btn--outline btn--sm" data-compare-clear>Clear all</button></div><div class="if-compare"><table>' + head + rows + '</table></div>';
    });
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-compare-remove]')) setTimeout(renderCompare, 30); });
  renderCompare();

  function renderWishlist() {
    var box = $('[data-wishlist-page]'); if (!box) return;
    var handles = store(WL);
    if (!handles.length) { box.innerHTML = '<div class="if-empty"><h3>Your wishlist is empty</h3><p>Tap the heart on any device to save it here.</p><a href="' + root + '/collections/all" class="btn btn--primary mt-16">Browse Devices</a></div>'; return; }
    getProducts(handles).then(function (ps) {
      box.innerHTML = '<div class="if-grid if-grid--4">' + ps.map(function (p) {
        return '<article class="if-card"><div class="if-card__actions"><button type="button" class="if-card__act is-active" data-wishlist-toggle="' + p.handle + '" data-wishlist-remove aria-label="Remove">&times;</button></div>' +
          '<a href="' + p.url + '" class="if-card__media">' + (p.featured_image ? '<img src="' + imgUrl(p.featured_image, 500) + '" alt="' + esc(p.title) + '">' : '') + '</a>' +
          '<div class="if-card__body"><h3 class="if-card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3><div class="if-card__foot"><span class="if-price">' + money(p.price) + '</span><a href="' + p.url + '" class="if-card__buy"><span>Buy</span></a></div></div></article>';
      }).join('') + '</div>';
    });
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-wishlist-remove]')) setTimeout(renderWishlist, 30); });
  renderWishlist();

  /* ---------- predictive search ---------- */
  var search = $('#ifSearch'), sInput = $('[data-search-input]'), sRes = $('[data-search-results]'), sHint = $('[data-search-hint]'), sQuick = $('[data-search-quick]');
  function openSearch() { if (!search) return; search.classList.add('is-open'); search.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; setTimeout(function () { sInput && sInput.focus(); }, 60); }
  function closeSearch() { if (!search || !search.classList.contains('is-open')) return; search.classList.remove('is-open'); search.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); closeDrawers(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  var sTimer, sCtrl;
  if (sInput) sInput.addEventListener('input', function () {
    var q = sInput.value.trim(); clearTimeout(sTimer);
    if (q.length < 2) { sRes.innerHTML = ''; sHint.hidden = false; sQuick.hidden = false; return; }
    sTimer = setTimeout(function () {
      if (sCtrl) sCtrl.abort(); sCtrl = window.AbortController ? new AbortController() : null;
      fetch(root + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', sCtrl ? { signal: sCtrl.signal } : {})
        .then(function (r) { return r.json(); }).then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          sHint.hidden = true; sQuick.hidden = true;
          if (!ps.length) { sRes.innerHTML = '<p class="if-search__hint">No devices found for “' + esc(q) + '”.</p>'; return; }
          sRes.innerHTML = ps.map(function (p) {
            var price = Math.round(parseFloat(p.price) * 100);
            return '<a class="if-sres" href="' + p.url + '">' + (p.image ? '<img src="' + imgUrl(p.image, 120) + '" alt="">' : '') + '<div><strong>' + esc(p.title) + '</strong><span>' + money(price) + '</span></div></a>';
          }).join('') + '<a class="if-search__all" href="' + root + '/search?type=product&q=' + encodeURIComponent(q) + '">View all results for “' + esc(q) + '” →</a>';
        }).catch(function () {});
    }, 220);
  });

  /* ---------- contact desk ---------- */
  var desk = $('#ifDesk');
  function closeDesk() { if (desk) desk.classList.remove('is-open'); }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-desk-toggle]') && desk) desk.classList.toggle('is-open'); });

  /* ---------- collection sort + filters ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page'); window.location.href = url.toString();
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) {
      var f = e.target.closest('form');
      $$('input[type=number]', f).forEach(function (i) { if (!i.value) i.disabled = true; });
      f.submit();
    }
  });
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('submit', function () { $$('input[type=number]', f).forEach(function (i) { if (!i.value) i.disabled = true; }); });
  });

  /* ---------- cart page qty forms ---------- */
  $$('[data-cart-page-qty]').forEach(function (inp) {
    inp.addEventListener('change', function () { inp.form.submit(); });
  });

  window.iflipCart = { refresh: function () { return fetchCart().then(renderCart); } };
})();
